import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Types and Action Creators
 */
const { Types, Creators } = createActions({
    setLocale: ['locale'],
});

export const LocaleTypes = Types;
export default Creators;

const initialState = global.autoLanguage ? `${global.languageUid}` : '';

/**
 * Initial State
 */
export const INITIAL_STATE = Immutable(initialState);

/**
 * Set the selected locale in the app state
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const setLocale = (state, action) => action.locale;

/**
 *  Hookup Reducers To Types
 */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_LOCALE]: setLocale,
});
